import React from 'react';
import { StyledColumnCover, StyledColumn, StyledColumnWrap, StyledColumnWrapper, StyledColumnDiv } from './styles';
import { SectionLightboxContext } from '../Lightbox';
export function ColumnDiv(props) {
  return /*#__PURE__*/React.createElement(StyledColumnDiv, {
    id: props.name,
    className: props.className,
    style: props.style
  }, props.children);
}
export function ColumnWrapper(props) {
  return /*#__PURE__*/React.createElement(StyledColumnWrapper, Object.assign({
    id: props.name,
    className: props.className,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}
export function ColumnWrap(props) {
  return /*#__PURE__*/React.createElement(StyledColumnWrap, Object.assign({
    id: props.name,
    className: props.className,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}
export function ColumnCover(props) {
  return /*#__PURE__*/React.createElement(StyledColumnCover, Object.assign({
    id: props.name,
    className: props.className,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}
export function Column(props) {
  return /*#__PURE__*/React.createElement(SectionLightboxContext.Provider, {
    value: props.lightbox
  }, /*#__PURE__*/React.createElement(StyledColumn, Object.assign({
    id: props.name,
    className: props.className,
    style: props.style,
    layout: props.layout,
    fullscreen: props.fullscreen,
    menu: props.menu,
    selecttheme: props.selecttheme
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children));
}